<template>
    <div>
    <div class="alumniStory">
        <loading :active.sync="isLoading" is-full-page="true"></loading>
        <vue-headful
            :title="'Allegheny College'+title"
        />
        <headerMain />
        <div class="alumniStoryWrapper" v-if="success">
            <div class="closeBtn" @click="goToHooper()" tabindex="0"  id="closePage" role="button" aria-label="close story modal">Close <img alt="page close image" src="../assets/close-button.svg" class="closeImg"><img alt="page close image" src="../assets/close-button-rollover.svg" class="closeImg hover"></div>
            <!-- <img src="../assets/close.png" class="closeImg"> -->
            <div class="alumniImgArea" :style="{backgroundImage: `url(${story.featured_image})` }">
                <div class="alumniImgDesc">
                    <h1 class="alumniImgDescHead">{{story.post_title}}</h1>
                    <h3 class="alumniImgDescSubHead">{{story.designation}}</h3>
                </div>
            </div>
            <div class="alumniStoryArea">
                <VuePerfectScrollbar class="scroll-alumniDescScroller" v-once :settings="alumniDescScroller">
                    <div class="alumniDescArea">
                        <h2 v-html="story.major_minors"></h2>
                        <div class="contentStory" v-html="story.post_content"></div>
                    </div>
                </VuePerfectScrollbar>
            </div>
        </div>
        <div class="alumniConnect">
            <div class="bgLeft"></div>
            <div class="bgRight"></div>
            <button class="yellowBannerButton bannerBtnDesktop openCounselorForm">Connect with a counselor</button>
        </div>
        
    </div>
    <counselorForm />
    </div>
</template>


<script>
    import axios from "axios";
     import { gsap } from 'gsap';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import counselorForm from '../components/counselorForm.vue';
    import headerMain from '../components/headerMain.vue';
    import Loading from 'vue-loading-overlay';
    import vueHeadful from 'vue-headful';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name:'aluministory',
        components: {
            VuePerfectScrollbar,
            counselorForm,
            headerMain,
            Loading,
            vueHeadful
        },
        data() {
            return {
                alumniDescScroller: {
                    maxScrollbarLength: 10,
                    swipeEasing: true,
                    suppressScrollX: false,
                    wheelSpeed: 0.1
                },
                story:{},
                success:false,
                isLoading:false,
                title:''
            }
        },
        created:function(){

            this.isLoading = true;

            let slug = this.$route.params.slug;

            axios.get("/wp-json/matrix/story/"+slug).then(response => {

                this.story = response.data.data;
                this.title = " - "+response.data.data.post_title;
                this.success = true;
                this.isLoading = false;
                

            });
            


        },
        mounted: function(){
            window.scrollTo(0,0)
            gsap.to(".header", 0, {
                y: "0%",
            });
            // document.body.addEventListener('keydown', function(event) {
            //     let closeBtn = document.getElementById("closePage");
            //     if (event.keyCode === 27 && typeof(closeBtn) != 'undefined' && closeBtn != null) {
            //         document.getElementById('closePage').click();
            //     }
            // });
        },
        methods:{

            goToHooper(){

                this.$router.push({name:'randomizer'});


            }
        }

    }

</script>


<style>
    @import "../styles/components/_alumnistory.scss";
</style>
